/* ---------------------------------------------------------------------------
 * MD Fashionwear — wishlist core (storage, hearts, badge, money)
 *
 * WHY THIS FILE EXISTS
 * layout/theme.liquid contains an older inline wishlist script guarded by
 *   if (!window.__mdWishlist) { ... }
 * This file loads from the <head> via snippets/js-variables.liquid, so it runs
 * first and claims the guard flag. The old block then skips itself entirely.
 * That lets us replace the logic without rewriting the 44KB layout file.
 *
 * DO NOT rename window.__mdWishlist — it is the handshake with the old block.
 * DO NOT add defer/async to the script tag — the old block runs during body
 * parsing, so a deferred load would lose the race and both would bind click
 * handlers, making every heart tap toggle twice and cancel itself out.
 *
 * MONEY FORMAT — ONE SHAPE ACROSS THE WHOLE STORE
 * Prices read AMOUNT then ISO CODE: "3,340.22 ALL".
 *
 * Intl with style:'currency' was used here before and it puts the code in FRONT
 * for currencies with no symbol, giving "ALL 3,340.22" on the wishlist while the
 * product page and cart said "3,340.22 ALL". Same store, two shapes. Use plain
 * decimal formatting and append the code, matching snippets/price-list.liquid.
 * ------------------------------------------------------------------------- */

window.__mdWishlist = true;

(function () {
  'use strict';

  var KEY = 'md_wishlist';

  /* ----------------------------------------------------------------- storage */

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      var seen = {};
      var out = [];
      for (var i = 0; i < raw.length; i++) {
        var h = raw[i];
        if (typeof h === 'string' && h && !seen[h]) { seen[h] = 1; out.push(h); }
      }
      return out;
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function announce(source) {
    document.dispatchEvent(new CustomEvent('wishlist:change', {
      detail: { handles: read(), source: source || 'unknown' }
    }));
  }

  function toggle(handle, source) {
    if (!handle) return;
    var handles = read();
    var i = handles.indexOf(handle);
    if (i > -1) handles.splice(i, 1);
    else handles.push(handle);
    write(handles);
    sync();
    announce(source || 'toggle');
  }

  function remove(handle, source) {
    var handles = read();
    var i = handles.indexOf(handle);
    if (i === -1) return;
    handles.splice(i, 1);
    write(handles);
    sync();
    announce(source || 'remove');
  }

  /* ------------------------------------------------------------------ money */

  // /products/{handle}.js returns the price in the visitor's ACTIVE presentment
  // currency, not the shop currency.
  function formatMoney(cents) {
    // Prefer the cart formatter so there is a single implementation on pages
    // where both scripts are present.
    if (window.MDCartSync && window.MDCartSync.fmt) return window.MDCartSync.fmt(cents);

    var amount = (Number(cents) || 0) / 100;
    var n;
    try {
      n = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      n = amount.toFixed(2);
    }

    var code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return code ? n + ' ' + code : n;
  }

  /* --------------------------------------------------- hearts + count badge */

  var queued = false;

  function syncNow() {
    queued = false;
    var handles = read();

    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var on = handles.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    var counters = document.querySelectorAll('[data-wishlist-count]');
    for (var j = 0; j < counters.length; j++) {
      counters[j].textContent = handles.length > 0 ? handles.length : '';
      counters[j].classList.toggle('is-visible', handles.length > 0);
    }
  }

  // Batched. requestAnimationFrame is frozen in a background tab, so fall back to
  // a timer when hidden, otherwise the badge goes stale for anyone who opens the
  // store in a background tab.
  function sync() {
    if (queued) return;
    queued = true;
    if (!document.hidden && typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(syncNow);
    } else {
      setTimeout(syncNow, 0);
    }
  }

  /* ---------------------------------------------------------------- wiring */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    toggle(btn.getAttribute('data-wishlist-toggle'));
  }, true);

  function startObserver() {
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { sync(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    sync();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ------------------------------------------------------------ public API */

  window.MDWishlist = {
    get: read,
    set: write,
    has: function (handle) { return read().indexOf(handle) > -1; },
    toggle: toggle,
    remove: remove,
    clear: function () { write([]); sync(); announce('clear'); },
    formatMoney: formatMoney,
    sync: sync,
    syncNow: syncNow,
    announce: announce
  };
})();
